import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import './scripts/seedAuctionHouses';
import AuctioneerDashboard from './pages/AuctioneerDashboard';
import CreateAuction from './pages/CreateAuction';
import AuctionDetail from './pages/AuctionDetail';
import AdminDashboard from './pages/AdminDashboard';
import EditAuction from './pages/EditAuction';
import BulkImageUpload from './pages/BulkImageUpload';
import HowItWorks from './pages/HowItWorks';
import ManageBids from './pages/ManageBids';


// Import components
import Header from './components/shared/Header';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Auctions from './pages/Auctions';
import Predictions from './pages/Predictions';
import Leaderboard from './pages/Leaderboard';
import Login from './pages/Login';
import Register from './pages/Register';

// Context providers
import { AuthProvider } from './contexts/AuthContext';
import { WalletProvider } from './contexts/WalletContext';
import { AuctionHouseProvider } from './contexts/AuctionHouseContext';

function App() {
  return (
    <AuthProvider>
      <AuctionHouseProvider>
        <WalletProvider>
          <Router>
            <div className="App min-h-screen bg-gray-50">
              <Header />
              <main className="container mx-auto px-4 py-8">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/auctions" element={<Auctions />} />
                  <Route path="/predictions" element={<Predictions />} />
                  <Route path="/leaderboard" element={<Leaderboard />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/auctioneer/dashboard" element={<AuctioneerDashboard />} />
                  <Route path="/auctioneer/create-auction" element={<CreateAuction />} />
                  <Route path="/auctions/:auctionId" element={<AuctionDetail />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/auctioneer/edit-auction/:auctionId" element={<EditAuction />} />
                  <Route path="/auctioneer/bulk-upload/:auctionId" element={<BulkImageUpload />} />
                  <Route path="/how-it-works" element={<HowItWorks />} />
                  <Route path="/auctioneer/manage-bids/:auctionId" element={<ManageBids />} />
                </Routes>
              </main>
              
              {/* Toast notifications */}
              <Toaster 
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
            </div>
          </Router>
        </WalletProvider>
      </AuctionHouseProvider>
    </AuthProvider>
  );
}

export default App;